import {baseRequestService} from "../base.ts";
import {EventReturnPost} from "../../types/domain.ts";

export const eventsEventIdReturnPost = (eventId: string, data: EventReturnPost) => baseRequestService({
    url: `/events/${eventId}/return`,
    method: 'POST',
    data
})